import { useState } from 'react';
import { ICoursesByWeek } from '../../../graphql/types/queries/course';
import { CourseRow } from './CourseRow';
import { weeksSummary } from './weeksSummary';
import { ISummary, ListContainer } from '../LastCourses';

export const Weeker = ({ weeks, onSelect }: { weeks: ICoursesByWeek[]; onSelect: (e: ISummary) => void; }) => {
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const summary = weeksSummary(weeks);

  return (
    <ListContainer flexDirection={'column'}>
      {summary.map(x => {
        return (
          <CourseRow key={x.weekNumber} row={x} setHover={setHoveredRow} hoveredId={hoveredRow} onSelect={onSelect} />
        );
      })}
    </ListContainer>
  );
};
